import { render, staticRenderFns } from "./PatientMedicalRecordsModal.vue?vue&type=template&id=42eb138f&"
import script from "./PatientMedicalRecordsModal.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalRecordsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports